import { motion } from "framer-motion";
import { metrics } from "../../data/content";
import { staggerContainer, staggerItem, Overline } from "./Reveal";

export const Metrics = () => (
  <section
    data-testid="metrics-section"
    className="relative border-y border-[var(--border-subtle)] bg-surface"
  >
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="mb-10">
        <Overline>Impact</Overline>
        <p className="mt-3 text-lg md:text-xl text-secondary-c max-w-2xl leading-relaxed">
          Engineering outcomes, measured in what they changed for the business.
        </p>
      </div>

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border-subtle)] rounded-3xl overflow-hidden border border-[var(--border-subtle)]"
      >
        {metrics.map((m) => (
          <motion.div
            key={m.label}
            variants={staggerItem}
            data-testid={`metric-${m.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="group bg-[var(--bg-base)] p-6 md:p-8 hover:bg-surface-elevated transition-colors duration-300"
          >
            <p className="font-heading font-bold text-3xl md:text-5xl tracking-tight text-primary-c">
              {m.value}
            </p>
            <p className="mt-3 text-sm md:text-base font-medium text-primary-c">
              {m.label}
            </p>
            <p className="mt-1 text-xs md:text-sm text-tertiary-c leading-relaxed">
              {m.detail}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
